import { defineStore } from "pinia";

export const useEvaluationFileIndexStore = defineStore('evaluationFileIndex', {
    state: () => ({
        evaluationFileIndex: {},
        evaluationFileIndices: [],
    }),
    actions: {
        setEvaluationFileIndex(evaluationFileIndex) {
            this.evaluationFileIndex = evaluationFileIndex
        },
        setEvaluationFileIndices(evaluationFileIndices) {
            this.evaluationFileIndices = evaluationFileIndices
        },
        addEvaluationFileIndex(evaluationFileIndex) {
            this.evaluationFileIndices.unshift(evaluationFileIndex)
        },
        updateEvaluationFileIndex(evaluationFileIndex) {
            let index = this.evaluationFileIndices.findIndex(cl => cl.id === evaluationFileIndex.id)
            this.evaluationFileIndices.splice(index, 1, evaluationFileIndex)
        },
        deleteEvaluationFileIndex(evaluationFileIndex) {
            let index = this.evaluationFileIndices.findIndex(cl => cl.id === evaluationFileIndex.id)
            this.evaluationFileIndices.splice(index, 1)
        },
    },
});